export const openPhoneCall = (phoneNumber: string): void => {
  window.open(`tel:${phoneNumber}`, '_blank', 'noopener,noreferrer')
}
